import { IS_CLIENT } from '../../constants';
// Used for clientside image handling for Image manager url:s
export const getAkamaiImageManagerSrc = (source, width) => {
    var _a, _b;
    let mappedSrc = decodeURIComponent(source);
    mappedSrc = mappedSrc.replace(/\s/g, '%20');
    // hm.options.isPublishMode is true for prod / test environments and false in author mode. We disable LP wrapping in author mode.
    const isPublishMode = IS_CLIENT && ((_b = (_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.isPublishMode);
    // If author is viewing preview of published page the isPublishMode will be true. This query will let us know not to use LP syntax for this usecase.
    const isPublishModeInAemEditor = IS_CLIENT && window.location.href.includes('?wcmmode=disabled');
    if (isPublishMode === false || isPublishModeInAemEditor) {
        return source;
    }
    if (!mappedSrc.includes('image.hm.com/')) {
        if (mappedSrc.includes('https://sellpy-parse-prod-files.s3.amazonaws.com')) {
            mappedSrc = mappedSrc.replace('https://sellpy-parse-prod-files.s3.amazonaws.com/', 'resell/');
        }
        if (mappedSrc.includes('https://hm.cdn.sellpy.net')) {
            mappedSrc = mappedSrc.replace('https://hm.cdn.sellpy.net/', 'resell/');
        }
        const akamaiDomain = process.env.AKAMAI_IMAGE_MANAGER_DOMAIN || 'https://image.hm.com';
        const slashCharacter = mappedSrc.startsWith('/') ? '' : '/';
        return `${akamaiDomain}${slashCharacter}${mappedSrc}?imwidth=${width}`;
    }
    if (!mappedSrc.includes('imwidth=')) {
        return `${mappedSrc}?imwidth=${width}`;
    }
    return mappedSrc.replace(/\?imwidth=.*/, `?imwidth=${width}`);
};
//# sourceMappingURL=getAkamaiImageManagerSrc.js.map